/** Clamp a capture timestamp into the available video range. */
export function clampVideoFrameTime(time: number, duration?: number | null): number {
  const safeTime = Number.isFinite(time) && time > 0 ? time : 0;
  if (duration == null || !Number.isFinite(duration) || duration < 0) return safeTime;
  return Math.min(safeTime, duration);
}

/** Compact seconds label for “at X seconds” capture copy. */
export function formatVideoFrameSeconds(time: number): string {
  const rounded = Math.round(clampVideoFrameTime(time) * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}
